// src/modules/app-views/leads/components/CardHeaderLeadsCol3.jsx
// *******************************************************************************
// CARD HEADER: Landing Page, Campaign, City-UF
// *******************************************************************************
// Column 3 of the leads document card header.
// Fields read from leadMeta: city, region (converted to UF), ip (tooltip), pageUrl.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { GlobalOutlined, FlagOutlined, EnvironmentOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import { getBrazilianStateUf } from 'utils/get-brazilian-state-uf';
import { LuDraftingCompass } from 'react-icons/lu';
import { baseTheme } from 'configs/appEngine';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderLeadsCol3 = ({ forceShow = false, ...record }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const landingPage = record?.landingPageData?.name || record?.landingPage || record?.source;
  const pageUrl = record?.landingPageData?.url || record?.leadMeta?.pageUrl;
  const campaign = record?.utm?.campaign || translateX('n_a');

  // City-UF from leadMeta: city in Pascal Case, region converted to 2-letter UF
  const city = record?.leadMeta?.city;
  const regionRaw = record?.leadMeta?.region;
  const uf = getBrazilianStateUf(regionRaw) || regionRaw?.toUpperCase();
  const cityUf = city && uf ? `${city} - ${uf}` : city || uf;
  const ip = record?.leadMeta?.ip;

  const items = [
    {
      key: 'landingPage',
      icon: <LuDraftingCompass style={{ color: baseTheme.colorPrimary }} />,
      label: landingPage,
      tooltipText: pageUrl || translateX('landing_page'),
      tooltipPlacement: 'right',
      onClick: pageUrl ? () => appService.handleCopyToClipboard(pageUrl, 'copied') : null,
    },
    {
      key: 'campaign',
      icon: <FlagOutlined />,
      label: campaign,
      tooltipText: translateX('campaign'),
      tooltipPlacement: 'right',
      onClick: null,
    },
    {
      key: 'cityUf',
      icon: <EnvironmentOutlined />,
      label: cityUf,
      tooltipText: ip || translateX('location'),
      tooltipPlacement: 'right',
      onClick: null,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items.filter(i => i?.label || forceShow)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderLeadsCol3;
